import APP from 'src/main.js'
import Trade from './Trade.js'

class IncomeTrade extends Trade {
  get income(){
    let value = (this.constructor.employeeStore.event_relations.find(rel => (rel.child_id === this.id)&&(rel.parent_type==='Income'))||{}).parent_id
    if(value){
      return this.constructor.employeeStore.events.find(ev => (ev.id === value)&&ev.id)
    } else {
      return null
    }
  }
  get coract(){
    return (this.income||{}).coract
  }
  get coract_id(){
    return (this.income||{}).coract_id
  }
  set coract_id(v){v}
}
export default IncomeTrade
